import React from 'react';
import { Link } from 'react-router-dom';
import SVG from 'react-inlinesvg';

const CombinedProjectsBackButton: React.FC = () => {
  return (
    <Link to="/yourprojects" className="back-button">
      <SVG src={require('assets/media/icons/backward_arrow_icon.svg')} />
      BACK
    </Link>
  );
};

export default CombinedProjectsBackButton;
